import {deToNumberString} from "../content/widgets/bloom-utils/transformations"
import moment from "moment"
import {validateEmail} from "../content/widgets/bloom-utils/validations"
import {toast} from "react-toastify"

const teMailRecipient = window._env_.TE_MAIL_RECIPIENT

const mapOptions = (result) => result?.map(({_links, key, name}) => ({
    key: key, id: key, label: name, value: key, _links,
})) ?? []

const mapKrankenkasse = (result) => result?.map(({label, beitragsatz}) => {
    return ({
        key: label, id: label, label, value: beitragsatz,
    })
}) ?? []

const pointerModel = {
    beruflicherStatus: "/beruflicheDaten/beruflicherStatus",
    besoldungstabelle: "/beruflicheDaten/besoldungstabelle",
    besoldungsgruppe: "/beruflicheDaten/besoldungsgruppe",
    stufen: "/beruflicheDaten/besoldungsstufe",
    gkv: "/kVInput/gKV",
    gkvBeitragssatz: "/kVInput/beitragssatz",
    gkvName: "/kVInput/gkvName",
}

const pointerBackendStorage = {
    besoldungstabelleAoed: "/backendstorage/beruflicheDaten/besoldungstabelle/aoed",
    besoldungstabelleBeamte: "/backendstorage/beruflicheDaten/besoldungstabelle/beamte",
    aktuelleTabelle: "/backendstorage/beruflicheDaten/besoldungstabelle/currentTable",
    besoldungsgruppe: "/backendstorage/beruflicheDaten/besoldungsgruppe",
    stufen: "/backendstorage/beruflicheDaten/stufen",
    gkvListstufen: "/backendstorage/beruflicheDaten/stufen",
    gkvList: "/backendstorage/beruflicheDaten/gkvList",
}

const GKV_SONSTIGE = "Sonstige"
const TOAST_ID_MISSING_FIELDS = "te-kontaktdaten-missing-fields"
const TOAST_ID_INVALID_MAIL = "te-kontaktdaten-invalid-mail"

const generateMailText = ({vorname, nachname, telefonnummer,mail}) => [
    vorname ? `Vorname : ${vorname}` : null,
    nachname ? `Nachname : ${nachname}` : null,
    telefonnummer ? `Telefonnummer : ${telefonnummer}` : null,
    mail ? `E-Mail-Adresse : ${mail}` : null,
].filter(el => el).join("<br/>")

const roundToFourDecimals = (num) => {
    return Math.round(num * 10000) / 10000
}

const formatBeitragssatz = (beitragssatz) => roundToFourDecimals(
    typeof beitragssatz === "string"
        ? Number(deToNumberString(beitragssatz)) / 100
        : beitragssatz / 100,
)

const accessNotGranted = (getDataFromPointer) => getDataFromPointer("/appstate/tariferhoehungsrechner/kontaktmodalOpen")

export const TariferhoehungsActions = ({
                                           getDataFromBackend,
                                           getDataFromPointer,
                                           updateData,
                                           sendDataToBackend,
                                           theme,
                                       }) => {

    const doCalculation = () => {
        if (accessNotGranted(getDataFromPointer)) {
            return
        }
        const beruflicheDaten = getDataFromPointer("/beruflicheDaten")
        const steuerlicheDaten = getDataFromPointer("/steuerlicheDaten")
        const kVInput = getDataFromPointer("/kVInput")
        const beObject = {
            "berufsstand": beruflicheDaten.beruflicherStatus,
            "verguetungstabelle": beruflicheDaten?.besoldungstabelle?.id,
            "verguetungsstufe": beruflicheDaten?.besoldungsstufe?.id,
            "verguetungsgruppe": beruflicheDaten?.besoldungsgruppe?.id,
            "steuerklasse": steuerlicheDaten.steuerklasse,
            "kVInput": {
                "art": kVInput.art,
                "monatlicherKVUPVBeitrag": kVInput.monatlicherKVUPVBeitrag,
                "gKV": kVInput.gKV?.label,
                "beitragssatz": formatBeitragssatz(kVInput.beitragssatz),
            },
        }

        sendDataToBackend(getDataFromPointer("/links/berechne"), beObject).then(({_data: data}) => {
            const parsedAktuellesNettoeinkommen = Number(deToNumberString(data[0]?.aktuellesNettoeinkommen ?? "0"))
            const abrundenAufTausender = Math.floor(parsedAktuellesNettoeinkommen / 1000) * 1000

            const min = Math.max(
                0,
                Math.min(
                    abrundenAufTausender,
                    Math.floor((parsedAktuellesNettoeinkommen - 500) / 500) * 500,
                ),
            )
            const mappedChart = ({
                bottomLabels: data.map(({datum}) => moment(datum).format("MM/YY")),
                datasets: [{
                    label: "aktuelles Nettoeinkommen",
                    data: data?.map(({aktuellesNettoeinkommen}) => Number(deToNumberString(aktuellesNettoeinkommen))),
                    backgroundColor: theme.BARCOLORS.first,
                    barThickness: 64,
                }, {
                    label: "Nettoerhöhung",
                    data: data?.map(({differenzAktuellesNettoeinkommen}) => Number(deToNumberString(differenzAktuellesNettoeinkommen))),
                    backgroundColor: theme.BARCOLORS.second,
                    barThickness: 64,
                }],
                min,
            })
            const mappedTableData = data.map(dataset => ({
                date: moment(dataset.datum).format("MM/YYYY"),
                bruttoeinkommen: dataset.bruttoeinkommen,
                steuern: dataset.steuern.steuerGesamt,
                rentenversicherung: dataset.sozialabgaben.rentenbeitrag,
                arbeitslosenversicherung: dataset.sozialabgaben.arbeitslosenbeitrag,
                krankenversicherung: dataset.sozialabgaben.krankenbeitrag,
                pflegebeitrag: dataset.sozialabgaben.pflegebeitrag,
                nettoeinkommen: dataset.nettoeinkommen,
                aktuellesNettoeinkommen: dataset.aktuellesNettoeinkommen,
                differenzAktuellesNettoeinkommen: dataset.differenzAktuellesNettoeinkommen,
            }))
            updateData(mappedChart, "/chartData/results")
            updateData(mappedTableData, "/tableData/results")
        })
    }

    const autoStepBerufsstand = async () => {
        const beruflicherStatus = getDataFromPointer(pointerModel.beruflicherStatus)
        const table = getDataFromPointer(
            beruflicherStatus === "ARBEITNEHMER_OED"
                ? pointerBackendStorage.besoldungstabelleAoed
                : pointerBackendStorage.besoldungstabelleBeamte,
        )
        if (table?.length > 0) {
            updateData(table, pointerBackendStorage.aktuelleTabelle)
            updateData(table[0], pointerModel.besoldungstabelle)
            await autoStepGruppe()
        }
    }

    const autoStepGruppe = async () => {
        const link = getDataFromPointer(pointerModel.besoldungstabelle)?._links?.gruppenList
        if (link) {
            await getDataFromBackend(link, pointerBackendStorage.besoldungsgruppe, mapOptions)
            const data = getDataFromPointer(pointerBackendStorage.besoldungsgruppe)
            if (data?.length > 0) {
                updateData(data[0], pointerModel.besoldungsgruppe)
                await autoStepStufe()
            }
        }
    }

    const autoStepStufe = async () => {
        const link = getDataFromPointer(pointerModel.besoldungsgruppe)?._links?.stufen
        if (link) {
            const stufenPointer = pointerBackendStorage.stufen
            await getDataFromBackend(link, stufenPointer, mapOptions)
            const data = getDataFromPointer(stufenPointer)
            if (data?.length > 0) {
                updateData(data[0], pointerModel.stufen)
                doCalculation()
            }
        }
    }

    const setGkv = async (gkv) => {
        if (gkv) {
            await updateData(gkv, pointerModel.gkv)
            await updateData(gkv.label, pointerModel.gkvName)
            await updateData(gkv.value * 100, pointerModel.gkvBeitragssatz)
        }
    }

    return {
        "TE_INIT": async () => {
            updateData(theme.BARCOLORS.first, "/chartData/results/datasets/0/backgroundColor")
            updateData(theme.BARCOLORS.second, "/chartData/results/datasets/1/backgroundColor")
            if (!window._env_.TARIFERHOEHUNG_BACKEND_API_URL) {
                return
            }
            await getDataFromBackend(getDataFromPointer("/links/getGKVList"), pointerBackendStorage.gkvList, mapKrankenkasse)
            const gkvList = getDataFromPointer(pointerBackendStorage.gkvList)
            const defaultVal = gkvList.find(el => el.label === GKV_SONSTIGE)
            await setGkv(defaultVal)
            await getDataFromBackend(getDataFromPointer("/links/ermittleArbeitnehmerOEDTabellen"), pointerBackendStorage.besoldungstabelleAoed, mapOptions)
            await getDataFromBackend(getDataFromPointer("/links/ermittleBeamteTabellen"), pointerBackendStorage.besoldungstabelleBeamte, mapOptions)
            await autoStepBerufsstand()
        },
        "TE_CHANGE_BERUFSSTAND": autoStepBerufsstand,
        "TE_CHANGE_TABELLE": autoStepGruppe,
        "TE_CHANGE_GRUPPE": autoStepStufe,
        "TE_CHANGE_STUFE": doCalculation,
        "TE_BERECHNE": doCalculation,
        "TE_CHANGE_KRANKENKASSE": async () => {
            const gkvList = getDataFromPointer(pointerBackendStorage.gkvList)
            const gkvObj = getDataFromPointer(pointerModel.gkv)
            if (gkvObj?.label) {
                const gkv = gkvList.find(el => el.label === gkvObj.label)
                await setGkv(gkv)
                doCalculation()
            }
        },
        "TE_BUTTON_PRINT": () => {
            window.print()
        },
        "TE_SEND_MAIL": () => {
            const daten = getDataFromPointer("/tariferhoehungsrechner/kontaktdaten")

            const hasMissingFields = Object.values(daten).includes("")
            if (hasMissingFields) {
                toast("Es müssen alle Felder ausgefüllt sein", {
                    toastId: TOAST_ID_MISSING_FIELDS,
                    type: "error",
                })
                return
            }
            toast.dismiss(TOAST_ID_MISSING_FIELDS)

            const mailCheck = validateEmail(daten.mail)
            if (mailCheck !== "") {
                toast(mailCheck, {
                    toastId: TOAST_ID_INVALID_MAIL,
                    type: "error",
                })
                return
            }
            toast.dismiss(TOAST_ID_INVALID_MAIL)
            if (teMailRecipient) {
                sendDataToBackend(getDataFromPointer("/links/sendMail"), {
                    "mailingList": [
                        teMailRecipient,
                    ],
                    "subject": "Der Tariferhöhungsrechner wurde benutzt",
                    "text": generateMailText(daten),
                    "from": "",
                    "attachments": [],
                    "dryRun": false,
                }).then(() => {
                    updateData(false, "/appstate/tariferhoehungsrechner/kontaktmodalOpen")
                    doCalculation()
                })
            }
        },
    }
}